export default class BaseService {
  headers: Headers = new Headers();

  constructor(unitId: string) {
    this.headers.append("X-UNIT-ID", unitId);
  }
}
